<template>
  <c-row>
    <c-col col="5">
      <c-card>
        <c-card-header>
          <strong>Information</strong>
        </c-card-header>
        <c-card-body>
          <form v-on:submit.prevent="save">
            <div class="form-group form-row">
              <label class="col-form-label col-sm-4">Jumlah Bayar</label>
              <div class="col-md-8">
                <input
                  type="number"
                  class="form-control"
                  v-bind:class="{'has-error': hasError.value}"
                  v-model="data.value"
                />
              </div>
            </div>
            <div class="form-group form-row">
              <label class="col-form-label col-sm-4">Tanggal Bayar</label>
              <div class="col-sm-8 input-group form-row">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <i class="cil-calendar"></i>
                  </div>
                </div>
                <datetime
                  class="date-control-calendar col-md-8"
                  v-model="data.created"
                  v-bind:class="{'has-error': hasError.created}"
                />
              </div>
            </div>
          </form>
        </c-card-body>
        <c-card-footer>
          <sr-button @onReset="reset" @onSave="save" @onUpdate="update" :object="debt" />
        </c-card-footer>
      </c-card>
    </c-col>
    <c-col col="7">
      <c-card>
        <c-card-header>
          <strong>Detail</strong>
        </c-card-header>
        <c-card-body>
          <table class="mtable" style="margin-bottom: 10px">
            <tr>
              <td width="100">Kepada</td>
              <td width="10">:</td>
              <td colspan="8">
                <label
                  class="label bg-primary"
                  v-if="debt.supplier"
                >{{ debt.supplier.name }}</label>
              </td>
            </tr>
            <tr>
              <td>Tanggal Mulai</td>
              <td width="10">:</td>
              <td>
                <label class="label bg-primary">{{debt.created_at | dateFormat}}</label>
              </td>
              <td width="90">Jatuh Tempo</td>
              <td width="10">:</td>
              <td colspan="4">
                <label class="label bg-warning">{{debt.period | dateFormat}}</label>
              </td>
            </tr>
            <tr>
              <td>Total</td>
              <td>:</td>
              <td>
                <label class="label bg-primary">{{debt.total | thousandSeparator}}</label>
              </td>
              <td>Terbayar</td>
              <td>:</td>
              <td width="80">
                <label class="label bg-success">{{debt.paid | thousandSeparator}}</label>
              </td>
              <td>Sisa</td>
              <td>:</td>
              <td>
                <label
                  class="label bg-danger"
                >{{(debt.total - debt.paid) | thousandSeparator}}</label>
              </td>
            </tr>
          </table>
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Ke</th>
                <th>Jumlah</th>
                <th>Tgl Bayar</th>
                <th>Petugas</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(d, k) in debt.debt_details" :key="k">
                <td align="center">{{k + 1}}</td>
                <td align="right">{{d.value | thousandSeparator}}</td>
                <td align="right">{{d.created | dateFormat}}</td>
                <td>
                  <span v-if="d.user">{{d.user.name}}</span>
                </td>
                <td width="10" style="text-align: center;">
                  <button class="btn-outline-danger btn btn-action" @click="doDelete(d)">
                    <i class="cil-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </c-card-body>
      </c-card>
    </c-col>
    <CModal title="Delete Confirmation" size="sm" color="danger" :show.sync="deleteConfirm">
      Yakin Akan menghapus data {{deletedObject.name}}?
      <template #footer>
        <CButton @click="deleteConfirm = false" color="danger">Batal</CButton>
        <CButton @click="runDelete" color="success">Yakin</CButton>
      </template>
    </CModal>
  </c-row>
</template>
<script>
import SRButton from "../../components/SRButton";
import { HTTPAUTH } from "../../lib/httplib";
export default {
  components: {
    "sr-button": SRButton,
  },
  data() {
    return {
      hasError: [],
      debt: {},
      deleteConfirm: false,
      deletedObject: {},
      data: {
        created: new Date().toISOString()
      }
    };
  },
  created() {
    const params = this.$route.params;
    if (params.id) {
      this.get(params.id);
    }
  },
  methods: {
    get(id) {
      HTTPAUTH.get("/api/v1/debt/" + id).then(res => {
        this.debt = res.data.data;
      });
    },
    save() {
      HTTPAUTH.put(
        `/api/v1/debt/${this.debt.id}/detail`,
        this.data
      )
        .then(() => {
          this.$toasted.success("Submit Berhasil").goAway(2000);
          this.data.value = "";
          this.get(this.debt.id);
        })
        .catch(eres => {
          if (eres.response.data && eres.response.data.message) {
            this.hasError = eres.response.data.errors;
            this.$toasted.error(eres.response.data.message).goAway(2000);
          } else {
            this.$toasted.error(eres.response.data.user_message).goAway(2000);
          }
        });
    },
    doDelete(d) {
      this.deleteConfirm = true;
      this.deletedObject = d;
    },
    runDelete() {
      HTTPAUTH.delete(`/api/v1/debt/${this.deletedObject.id}/detail`)
        .then(() => {
          this.deleteConfirm = false;
          this.$toasted.success("Berhasil Dihapus").goAway(2000);
          this.get(this.deletedObject.debt_id);
        })
        .catch(eres => {
          this.$toasted.error(eres.response.data.user_message).goAway(2000);
        });
    },
    reset() {},
    update() {}
  }
};
</script>